import { Controller } from "@hotwired/stimulus"

// Collapsible "Live phases" rail. CTA stays visible; phase list can hide.
// Prefer open when ingest is busy; remember user preference in localStorage.
export default class extends Controller {
  static targets = ["toggle", "body", "chevron", "hint"]
  static values = {
    storageKey: { type: String, default: "cd-phase-cockpit-open" },
    // When true on connect, force open (e.g. busy pipeline).
    preferOpen: { type: Boolean, default: false }
  }

  connect() {
    let open = true
    try {
      const stored = window.localStorage?.getItem(this.storageKeyValue)
      if (stored === "0") open = false
      if (stored === "1") open = true
    } catch (_e) {
      // ignore
    }
    if (this.preferOpenValue) open = true
    // Phones: default collapsed unless busy or user forced open.
    if (window.matchMedia && window.matchMedia("(max-width: 767.98px)").matches) {
      if (!this.preferOpenValue) {
        try {
          const stored = window.localStorage?.getItem(this.storageKeyValue)
          if (stored == null) open = false
        } catch (_e) {
          open = false
        }
      }
    }
    this._setOpen(open, { persist: false })
  }

  toggle(event) {
    event?.preventDefault?.()
    this._setOpen(!this._open, { persist: true })
  }

  open() {
    this._setOpen(true, { persist: true })
  }

  close() {
    this._setOpen(false, { persist: true })
  }

  _setOpen(open, { persist }) {
    this._open = !!open
    this.element.classList.toggle("is-collapsed", !this._open)
    if (this.hasBodyTarget) {
      this.bodyTarget.hidden = !this._open
      this.bodyTarget.setAttribute("aria-hidden", this._open ? "false" : "true")
    }
    if (this.hasToggleTarget) {
      this.toggleTarget.setAttribute("aria-expanded", this._open ? "true" : "false")
    }
    if (this.hasChevronTarget) {
      this.chevronTarget.textContent = this._open ? "▾" : "▸"
    }
    if (this.hasHintTarget) {
      this.hintTarget.hidden = this._open
    }
    if (persist) {
      try {
        window.localStorage?.setItem(this.storageKeyValue, this._open ? "1" : "0")
      } catch (_e) {
        // ignore
      }
    }
  }
}
